import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { handleEscape } from "./app/actions";
import { ResponsiveFrame } from "./app/page/Frame";
import { createApplicationStore } from "./appsetup";
import { assertNonNullable } from "./utilities/assert";

declare global {
	interface Window {
		suppressClosePrompt: boolean;
	}
}

/**
 * Mount Page into the DOM.
 */
createApplicationStore().then(async store => {
	document.documentElement.lang = "de";

	const mountPoint = document.getElementById("root");
	assertNonNullable(mountPoint);

	const root = createRoot(mountPoint);
	root.render(
		<Provider store={store}>
			<ResponsiveFrame />
		</Provider>
	);

	document.addEventListener("keydown", event => {
		if (event.key === "Escape") {
			store.dispatch(handleEscape());
		}
	});
});
